export const TRACKING_EVENTS = {
  SAVE: `Custom Property - save`,
  // when clicking the "Save" button when new custom property, resulting in the Save/Share screen being shown
  SAVE_NEW: `Custom Property - save new`,
  DELETE: `Custom Property - delete`,
  INSERT_EXAMPLE: `Custom Property - insert example`,
  CANCEL: `Custom Property - cancel`,

  CLICK_UPSELL: `Click Upsell`,
};
